import Contentful from './Contentful'

export default Contentful
